<template lang="pug">
  - $image_path = '@/assets/images/game/present/';
  .view-present.present-type-view(ref="page" :class="`type-${presentType}`")
    .page-title
      p.page-title-text(ref="title"): img(:src="getTypeImage('title.png')")
      .page-title-decoration-white(ref="titleDecoration"): img(:src="getTypeImage('title_decoration_white.png')")
      .page-title-decoration-yellow(ref="titleDecoration"): img(:src="getTypeImage('title_decoration_yellow.png')")
    p.text(ref="text"): img(:src="getTypeImage('text.png')")
    .frame
      .score
        p.score-number.number-sprite-l(
          v-for="num in scoreList"
          :class="`number-${num}`"
        )
      .charactor-text(ref="charactorText"): img(:src="getTypeImage('text_charactor.png')")
      .charactor(ref="charactor"): img(:src="getTypeImage('image_charactor.png')")
      .apply(ref="apply" @click="playSound('se_click_button'); $emit('showApply');"): img(src=`${$image_path}button_apply.png`)
    button.button-retry(ref="retry" @click="retry"): img(src=`${$image_path}button_retry.png`)
    .button-top(ref="top")
      router-link(:to="{ name:'top' }" @click.native="playSound('se_click_button')")
        img(src=`${$image_path}button_top.png`)
</template>

<script>
import { TimelineMax, TweenMax } from 'gsap';
import { mapGetters } from 'vuex';

import CountUp from '@/assets/js/CountUp';
import SoundController from '@/assets/js/SoundController';
import Utils from '@/assets/js/Utils';

export default {
  name: 'Present',
  data() {
    return {
      scoreCounter: null,
      scoreList: [0]
    };
  },
  computed: {
    ...mapGetters(['totalScore', 'presentType'])
  },
  beforeDestroy() {
    this.scoreCounter.stop();
  },
  mounted() {
    this.startTimelineAnimation();
    const onPresentCountUp = () => {
      this.scoreCounter = new CountUp(this.totalScore, count => {
        SoundController.play('se_add_score');
        this.scoreList = Utils.getNumberToList(count);
      });
    };
    Utils.addTimer({ key: 'presentCountUp', time: 1250 }, onPresentCountUp);
  },
  methods: {
    getTypeImage(filename) {
      return require(`@/assets/images/game/present/${
        this.presentType
      }/${filename}`);
    },
    startTimelineAnimation() {
      const timeline = new TimelineMax();
      const zoom = (target, duration, animationTimeline) => {
        const halfDuration = duration * 0.5;
        animationTimeline
          .fromTo(
            target,
            halfDuration,
            { opacity: 0, transform: 'scale(0)' },
            { opacity: 0.5, transform: 'scale(1.5)' }
          )
          .to(target, halfDuration, { opacity: 1, transform: 'scale(1)' });
      };
      const slideUp = (target, duration, animationTimeline) => {
        const y = target.clientHeight * 0.3;
        animationTimeline.fromTo(
          target,
          duration,
          { y: y, opacity: 0 },
          { y: 0, opacity: 1 }
        );
      };

      zoom(this.$refs.title, 0.5, timeline);
      timeline.fromTo(
        this.$refs.titleDecoration,
        0.5,
        { opacity: 0 },
        { opacity: 1 }
      );

      zoom(this.$refs.text, 0.5, timeline);

      const charactorX = this.$refs.charactor.clientWidth * 0.5;
      const charactorY = this.$refs.charactor.clientWidth * 0.2;
      timeline.fromTo(
        this.$refs.charactor,
        0.5,
        { x: charactorX, y: charactorY, opacity: 0 },
        { x: 0, y: 0, opacity: 1 }
      );
      slideUp(this.$refs.charactorText, 0.5, timeline);
      slideUp(this.$refs.apply, 0.5, timeline);
      slideUp(this.$refs.retry, 0.5, timeline);
      slideUp(this.$refs.top, 0.5, timeline);
    },
    retry() {
      SoundController.play('se_click_button');
      this.$emit('onRetry');
    },
    playSound(key) {
      SoundController.play(key);
    }
  }
};
</script>

<style scoped lang="scss">
.view-present {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  @include present-type-image;
  &.type-m {
    .frame {
      .charactor-text {
        position: absolute;
        top: vw(210);
        left: vw(310);
        width: vw(865);
      }
      .charactor {
        position: absolute;
        top: vw(208);
        left: vw(-90);
        width: vw(499);
      }
    }
  }
  &.type-l {
    .frame {
      .charactor-text {
        position: absolute;
        top: vw(210);
        left: vw(310);
        width: vw(865);
      }
      .charactor {
        position: absolute;
        top: vw(210);
        left: vw(-100);
        width: vw(562);
      }
    }
  }
  .page-title {
    position: absolute;
    top: vw(108);
    left: vw(100);
    z-index: 1;
    &-text {
      width: vw(1080);
    }
    &-decoration {
      &-white {
        position: absolute;
        top: vw(-5);
        left: vw(15);
        width: vw(777);
        animation: flash-fade-in 0.8s 1.2s ease infinite;
      }
      &-yellow {
        position: absolute;
        top: vw(-71);
        left: vw(-62);
        width: vw(1182);
        animation: flash-fade-out 0.8s 1.2s ease infinite;
      }
    }
  }
  .text {
    width: vw(1005);
    margin: vw(356) auto 0;
  }
  .frame {
    position: relative;
    width: vw(1160);
    height: vw(900);
    margin: vw(26) auto 0;
    background: image-url('game/present/image_frame.png') no-repeat;
    background-size: contain;
    z-index: 0;
    .score {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      position: absolute;
      top: vw(-8);
      right: vw(85);
      z-index: 1;
      &-number {
        margin-left: vw(-18);
        &:first-child {
          margin-left: 0;
        }
      }
    }
    .charactor-text {
      position: absolute;
      top: vw(215);
      left: vw(-43);
      width: vw(875);
    }
    .charactor {
      position: absolute;
      top: vw(162);
      right: vw(-50);
      width: vw(385);
    }
    .apply {
      position: absolute;
      top: vw(619);
      left: vw(130);
      width: vw(900);
      a {
        display: block;
      }
    }
  }
  .button-retry {
    display: block;
    width: vw(816);
    margin: vw(80) auto 0;
  }
  .button-top {
    width: vw(816);
    margin: vw(40) auto 0;
    a {
      display: block;
    }
  }
  .number-sprite-l {
    background-image: image-url('game/number_l_spritesheet.png');
  }
}
</style>
